<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" :id="id" tabindex="-1" role="dialog" :aria-labelledby="$id('reservedOrdersModal')" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" :id="$id('reservedOrdersModal')">{{header}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                            <table class="table table-responsive">
                                <thead>
                                    <tr>
                                        <th>{{$t('page.product.edit.modal.id')}}</th>
                                        <th>{{$t('page.product.edit.modal.order_number')}}</th>
                                        <th>{{$t('page.product.edit.modal.reserved')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="order in orders">
                                        <td><a href="#" @click="openOrder(order.id)">{{order.id}}</a></td>
                                        <td><a href="#" @click="openOrder(order.id)">{{order.orderNumber}}</a></td>
                                        <td>{{order.reserved}}</td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" data-dismiss="modal">{{$t('page.product.edit.modal.ok')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import QuestionModal from "../QuestionModal";

    export default {
        name: "ReservedOrdersModal",
        components: {
            QuestionModal,
        },
        data: function() {
            return {
                header: "",
                orders: [],
            }
        },
        props:{
            id: {
                required: true,
            },
        },
        beforeMount: function(){
            this.header = this.$t('page.product.edit.modal.reserved_stock');
        },
        methods:{
            loadReservedOrders: function(stockId){
                let vue = this;

                axios.get('/article/stock/reserved_orders/' + stockId)
                .then(function (response) {
                    let data = response["data"];

                    vue.orders = [];
                    data.forEach(function (order) {
                        vue.orders.push({
                            id: order.id,
                            orderNumber: order.order_number,
                            reserved: order.reserved
                        });
                    })
                })
            },
            openOrder: function (orderId) {
                window.open('/order/detail/' + orderId);
            }
        }
    }
</script>
